import React from 'react';
import { exportDiffAsText } from '../utils/diffEngine';

export default function RawDiff({ diffResult, original, modified }) {
  const rawDiffText = diffResult ? exportDiffAsText(diffResult) : '';

  const handleCopy = () => {
    navigator.clipboard.writeText(rawDiffText);
  };

  if (!diffResult) {
    return (
      <div className="raw-diff empty">
        <div className="empty-state">
          <p className="empty-message">No diff to display</p>
        </div>
      </div>
    );
  }

  return (
    <div className="raw-diff">
      <div className="raw-diff-header">
        <button className="copy-btn" onClick={handleCopy}>
          📋 Copy to Clipboard
        </button>
      </div>
      <pre className="raw-diff-content">{rawDiffText}</pre>
    </div>
  );
}
